/* eslint-disable spellcheck/spell-checker */
const Configs = require('./Configs')
const request = require('request-promise')
const AuthenticationContext = require('adal-node').AuthenticationContext

class PowerBiAdapter {
  /**
   * @param {*} configs
   * @param {*} authContext
   */
  constructor (configs, authContext) {
    this.setConfigs(configs || {})
    this.setRequestFunction(null)

    this.authContext = authContext || new AuthenticationContext(this.authorityHostUrl)
  }

  /**
   * @param {Request} requestFunction
   */
  setRequestFunction (requestFunction) {
    this.request = requestFunction || request
  }

  setConfigs (configs) {
    this.pbiUsername = configs.pbiUsername || Configs.GetEnvironmentVariable('PBI_USERNAME')
    this.pbiPassword = configs.pbiPassword || Configs.GetEnvironmentVariable('PBI_PASSWORD')
    this.pbiRessource = configs.pbiRessource || Configs.GetEnvironmentVariable('PBI_RESSOURCE')
    this.pbiClientId = configs.pbiClientId || Configs.GetEnvironmentVariable('PBI_CLIENT_ID')
    this.pbiTenant = configs.pbiTenant || Configs.GetEnvironmentVariable('PBI_TENANT')
    this.authorityHostUrl =
      'https://login.microsoftonline.com/' + this.pbiTenant + '/oauth2/token'
    this.authContext = new AuthenticationContext(this.authorityHostUrl)
  }

  /**
   *
   * @param {Request} body
   */
  async getPowerBiEmbedToken (body) {
    // validate that all the required config attrbuts are correctly set
    this.validate()
    // check th
    if (body === null || body === undefined) {
      throw Error({ code: 101, message: 'requette malformée' })
    }
    const pbiReqdata = this.setIdentities({
      groupId: body.groupId,
      reportId: body.reportId,
      embedRequestBody: {
        accessLevel: 'view'
      }
    }, body)

    pbiReqdata.accessToken = await this.getAzureAccessToken()
    const embedTokenResult = await this.requestEmbedToken(pbiReqdata)

    return {
      embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=' + pbiReqdata.reportId + '&groupId=' + pbiReqdata.groupId,
      embedToken: embedTokenResult.token,
      reportId: pbiReqdata.reportId,
      tokenType: 'Embed'
    }
  }

  /**
   *
   * @param {Object} data
   */
  requestEmbedToken (data) {
    var options = {
      method: 'POST',
      uri: 'https://api.powerbi.com/v1.0/myorg/groups/' + data.groupId + '/reports/' + data.reportId + '/GenerateToken',
      body: data.embedRequestBody,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + data.accessToken
      },
      json: true
    }
    const self = this
    return new Promise(function (resolve, reject) {
      self.request(options)
        .then(embedTokenResult => {
          resolve(embedTokenResult)
        }).catch(err => {
          reject(new Error(JSON.stringify({ code: 103, error: err })))
        })
    })
  }

  /**
   * TODO: describe this function
   */
  getAzureAccessToken () {
    const self = this
    return new Promise(function (resolve, reject) {
      self.authContext.acquireTokenWithUsernamePassword(
        self.pbiRessource,
        self.pbiUsername,
        self.pbiPassword,
        self.pbiClientId,
        function (err, accessTokenResult) {
          if (err) {
            reject(new Error(JSON.stringify({ code: 102, error: err })))
          } else {
            resolve(accessTokenResult.accessToken)
          }
        }
      )
    })
  }

  /**
   * this method set the identities to data embededRequestBody key
   * @param {Object} data : data from PowerBI API
   * @param {Object} reqBody : body of the Request
   */
  setIdentities (data, reqBody) {
    const identityKeyMaping = {
      userId: 'username',
      roles: 'roles',
      datasets: 'datasets',
      customData: 'customData'
    }
    const dataClone = JSON.parse(JSON.stringify(data))
    const identity = this.buildIdentityObject(identityKeyMaping, reqBody)
    if (!this.isEmpty(identity)) {
      dataClone.embedRequestBody['identities'] = [identity]
    }
    return dataClone
  }
  /**
   * this method ma the request Body with the identity key and build an identity Object
   * @param {Object} identityKeyMaping : all key for the identity mapping
   * @param {Object} requestBody : Body of the request
   */
  buildIdentityObject (identityKeyMaping, requestBody) {
    if (requestBody !== null && requestBody !== undefined) {
      return Object.keys(identityKeyMaping)
        .filter(x => {
          return requestBody[x] !== null && requestBody[x] !== undefined
        }) // only retrieve the selected identity key found in the request
        .map(x => {
          const obj = {}
          obj[identityKeyMaping[x]] = requestBody[x]
          return obj
        }) // for each key found get the corresponding sent value
        .reduce((x, y) => Object.assign(x, y), {}) // merge the key/value withing a single dict
    } else {
      return {}
    }
  }
  /**
   * verify if an object is empty or not
   * @param {Object} object
   */
  isEmpty (object) {
    return Object.keys(object).length === 0
  }

  /**
   * Get all the required attributs
   */
  allRequiredAttributs () {
    return this.getAllMatchingRequried(Object.getOwnPropertyNames(this))
  }

  /**
   * Check if a given attribut matches the required regex expression
   * @param {string} attribut
   */
  matchRequired (attribut) {
    return attribut.match(/^pbi.+$/g)
  }

  /**
   * Get all attributs matching the required regex expression
   * @param {Array} attributs
   */
  getAllMatchingRequried (attributs) {
    return attributs.filter(this.matchRequired)
  }

  /**
   * Check if a given attribut is not set inthe given class instance
   * @param {string} attribut
   * @param {Object} object
   */
  attributIsNotSet (attribut, object) {
    return object[attribut] === null || object[attribut] === undefined
  }

  /**
   * Get all attributs from the list that are not set in the given Class instance
   * @param {Array} attributs
   * @param {Object} object
   */
  getAllNotSetAttributs (attributs, object) {
    return attributs.filter(function (attribute) {
      return object.attributIsNotSet(attribute, object)
    })
  }

  /**
   * Validate pbi* attributs
   */
  validate () {
    const requiredAttributs = this.allRequiredAttributs()
    const allNotSetAttributs = this.getAllNotSetAttributs(requiredAttributs, this)
    if (allNotSetAttributs.length > 0) {
      throw new Error(JSON.stringify({
        code: 100,
        required: allNotSetAttributs,
        error: allNotSetAttributs.join(',') + ' are required'
      }))
    } else {
      return true
    }
  }
}
module.exports = PowerBiAdapter
